import Settings from '@mui/icons-material/Settings';
import List from '@mui/icons-material/List';
import SentimentSatisfied from '@mui/icons-material/SentimentSatisfied';
import Assignment from '@mui/icons-material/Assignment';
import Description from '@mui/icons-material/Description';

export const routes = [
  {
    user: true,
    path: '/modifier-profil',
    name: 'Modifier mon profil',
    icon: Settings,
  },
  {
    path: '/classes',
    name: 'Mes classes',
    icon: List,
  },
  {
    path: '/annonces',
    name: 'Les offres disponibles',
    icon: Description,
  },
  {
    path: '/eleves',
    name: 'Les élèves de mon collège',
    icon: SentimentSatisfied,
  },
  {
    path: '/contact',
    name: 'Je contacte VVMT',
    icon: Assignment,
  },
];
